<div class="btn-container">
  <p class="step-title">{{ 'symptomAssessment.symptomDetails.valutation_details' | translate }}</p>
  <ds-button [width]="'small'" class="consulta-medico" [text]="'symptomAssessment.symptomDetails.button_consult' | translate" (click)="medicalConsultation()"> </ds-button>
  <p style="margin-bottom: 10px">{{ 'symptomAssessment.symptomDetails.number_text' | translate }}</p>
  <ng-container> </ng-container>
  <ds-select
    [placeholder]="'symptomAssessment.symptomDetails.select_emergency_number' | translate"
    [texts]="countryDescriptions"
    [values]="countryIds"
    [control]="emergencyForm?.get('destination')"
  ></ds-select>

  <ds-button
    [width]="'small'"
    class="emergency-button"
    (click)="callToEmergency()"
    [text]="('symptomAssessment.symptomDetails.call_btn' | translate) + (selectedCountryNumber || '')"
  >
  </ds-button>
</div>

<div class="summary-container" id="print-section">
  @if (diagnosis.diagnoses && diagnosis.diagnoses.length) {
    <div>
      <p class="title">{{ 'symptomAssessment.symptomDetails.analisi' | translate }}</p>
      @for (probability of diagnosis.diagnoses; track probability) {
        <div>
          <ul>
            <li class="text">{{ probability.label }} {{ probability.probability }}%</li>
          </ul>
        </div>
      }
    </div>
  }
  @for (content of diagnosis.contents; track content) {
    <div>
      <p class="title">{{ content.title }}</p>
      <p class="text" [innerHTML]="content.text"></p>
      @if (content.contents && content.contents.length) {
        <div>
          @for (subContent of content.contents; track subContent) {
            <div>
              <p class="title-contents">{{ subContent.title }}</p>
              <p class="text-contents" [innerHTML]="subContent.text"></p>
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="button-container">
    <ds-button style="margin-right: 10px" [text]="'CHIUDI'" [styleType]="'empty-main'" [width]="'small'" (click)="back()"></ds-button>
    @if (!onMobile) {
      <ds-button [text]="'STAMPA'" [width]="'small'" (click)="printSection()"></ds-button>
    }
  </div>
</div>
